import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { Confidence, Item, Scores } from '@mas-flow/types';
import * as votesApi from '../api/votes';
import { ITEMS_KEY, itemKey } from './useItems';

export function useCastVote() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ itemId, partial }: { itemId: string; partial: { scores?: Partial<Scores>; confidence?: Confidence | null } }) =>
      votesApi.cast(itemId, partial),
    onSuccess: (item) => {
      qc.setQueryData(itemKey(item.id), item);
      qc.setQueryData<Item[]>(ITEMS_KEY, (prev) => prev?.map((x) => (x.id === item.id ? item : x)));
    },
    onError: (_e, vars) => {
      qc.invalidateQueries({ queryKey: itemKey(vars.itemId) });
      qc.invalidateQueries({ queryKey: ITEMS_KEY });
    },
  });
}

export function useWithdrawVote() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ itemId }: { itemId: string }) => votesApi.withdraw(itemId),
    onSuccess: (item) => {
      qc.setQueryData(itemKey(item.id), item);
      qc.setQueryData<Item[]>(ITEMS_KEY, (prev) => prev?.map((x) => (x.id === item.id ? item : x)));
    },
  });
}
